import React from 'react';
import InnerLeadPreviewPropertyList from '../../property/InnerLeadPreviewPropertyList';
import withRouter from '../../../util/WithRouter';

class PropertyTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
      <div className={`tab-pane fade ${tab === 'property' ? 'show active in' : ''}`}>
        <div className="row">
          <div className="col-md-12">
            <InnerLeadPreviewPropertyList id={this.props.id} type={this.props.type} {...this.props} edit={this.props.edit}
              reload={this.props.reload} />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(PropertyTab);